import { supabase } from '../lib/supabase';

export const setupUserScheduleTable = async () => {
  try {
    // First, let's check if the table exists by trying to query it
    const { error } = await supabase
      .from('user_schedule')
      .select('*')
      .limit(1);

    if (error) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};

export const setupEventSignupsTable = async () => {
  try {
    // First, let's check if the table exists by trying to query it
    const { error } = await supabase
      .from('event_signups')
      .select('*')
      .limit(1);

    if (error) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};

export const setupUsersTable = async () => {
  try {
    // Check if users table exists and has ticket_number column
    const { error } = await supabase
      .from('users')
      .select('ticket_number')
      .limit(1);

    if (error && error.code === '42703') { // Column doesn't exist
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};

export const checkDatabaseSetup = async () => {
  // Check events table
  try {
    const { error: eventsError } = await supabase
      .from('events')
      .select('*')
      .limit(1);
    
    if (eventsError) {
    } else {
    }
  } catch (error) {
  }

  // Check users table
  await setupUsersTable();

  // Check user_schedule table
  await setupUserScheduleTable();

  // Check event_signups table
  await setupEventSignupsTable();
}; 